import React from 'react';
import './Clients.css';
import { Container, Row, Col, Card, CardBody } from 'reactstrap';
import { FaCar, FaVideo, FaChargingStation, FaSuitcase, FaUserShield } from 'react-icons/fa';
import { Helmet } from "react-helmet";
import Footer from '../Footer';
import GoToTop from '../GoToTop/GoToTop';
import successStoriesBanner from '../../assets/successStoriesBanner.png';
import '../Blog/blog.css'

const clientData = [
    {
        name: "Vialumina Fleet Platform",
        problem: "Fleet operators lacked EV transition planning, real-time tracking, charging management, and cost visibility.",
        solution: "Built an end‑to‑end EV fleet platform with GPS tracking, battery analytics, charging management, and ROI dashboards.",
        icon: <FaCar className="client-icon" />,
        accent: "#4a90e2"
    },
    {
        name: "WiFido Streaming App",
        problem: "Client needed hardware–software integration for live video streaming with cross‑platform performance.",
        solution: "Built a cross‑platform mobile app with firmware integration and optimized real‑time streaming.",
        icon: <FaVideo className="client-icon" />,
        accent: "#f5a623"
    },
    {
        name: "CTEK Charging Apps",
        problem: "Users needed reliable charger connectivity, monitoring, and battery health insights.",
        solution: "Built smart charging apps with real‑time monitoring, diagnostics, scheduling, and connectivity.",
        icon: <FaChargingStation className="client-icon" />,
        accent: "#7ed321"
    },
    {
        name: "Mobileware Zoho Implementation",
        problem: "Unstructured sales workflows and inefficient customer support processes.",
        solution: "Implemented Zoho CRM & Desk with automation, analytics dashboards, and workflow optimization.",
        icon: <FaSuitcase className="client-icon" />,
        accent: "#bd10e0"
    },
    {
        name: "Zedbud iOS Platform",
        problem: "No iOS app and poor performance limited engagement and safety features.",
        solution: "Developed a secure iOS app with optimized performance, modern UI, and enhanced child safety features.",
        icon: <FaUserShield className="client-icon" />,
        accent: "#d0021b"
    }
];

const Clients = () => {
    return (
        <div>
            <Helmet>
                <title>Success Stories - KibbCom</title>
                <meta name="description" content="Explore how KibbCom empowers businesses through innovative technology solutions and expert software development." />
            </Helmet>
            <div className="clients-page-wrapper">
                <section className='blog-image-container'>
                    <div className='blog-HeadElement'>
                        <img src={successStoriesBanner} alt='success stories banner' className='blog-imgcls'></img>
                    </div>
                    <div className='blog-head-content'>
                        <h1 className='blog-HeadText'>Success Stories</h1>
                        <p style={{ color: 'white' }}>Empowering businesses with cutting-edge technology and impactful solutions.<br />We take pride in delivering excellence across diverse industrial domains.</p>
                    </div>
                </section>

                <section className='blogPageSection py-5'>
                    <div className='container'>
                        <div className='row'>
                            <div className='col-lg-12 col-md-12 col-sm-12'>
                                <div className='row justify-content-center'>
                                    {clientData.map((client, index) => (
                                        <div className='col-lg-4 col-md-6 col-sm-12 mb-4' key={index}>
                                            <Card className="client-card h-100 hvr-float">
                                                <CardBody>
                                                    <div className="icon-wrapper" style={{ backgroundColor: `${client.accent}15`, color: client.accent }}>
                                                        {client.icon}
                                                    </div>
                                                    <h3 className="client-name">{client.name}</h3>
                                                    <div className="client-detail">
                                                        <h4 className="detail-label">Problem</h4>
                                                        <p className="detail-text">{client.problem}</p>
                                                    </div>
                                                    <div className="client-detail">
                                                        <h4 className="detail-label">Solution</h4>
                                                        <p className="detail-text">{client.solution}</p>
                                                    </div>
                                                </CardBody>
                                                <div className="card-accent" style={{ backgroundColor: client.accent }}></div>
                                            </Card>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            <Footer />
            <GoToTop />
        </div>
    );
};

export default Clients;
